define('../app/fukit/view/block/tabs.container.view',['require','exports','module','uikit/uikit','underscore','marionette'],function(require, exports, module) {
  //prettier-ignore
  var UIKit = require('uikit/uikit'),
      _     = require('underscore'),
      Mn    = require('marionette');


  var TabsContainerView = UIKit.Tabs.extend({

    attributes: {
      style: 'margin-top: 1em;'
    },

    menuItemOptions: {
      basic: true,
      attached: false,
      padded: true
    },

    options: _.extend({}, UIKit.Tabs.prototype.options, {
      components: null,
      padded: true
    }),

    initialize: function() {
      UIKit.Tabs.prototype.initialize.apply(this, arguments);
      this.processTabComponents();
    },

    onChangeComponents: function() {
      this.processTabComponents();
    },

    processTabComponents: function() {
      var removedViews = this.empty();

      _.defer(function() {
        _.invoke(removedViews, 'destroy');
      });

      _.each(this.getComponents(), function(component) {
        if (!component) { return; }

        var contentView = this.buildComponent(_.extend({},
          Mn._getValue(component.tabContent, this)
        ));

        var menuItemView = this.buildComponent(_.extend({},
          Mn._getValue(this.getOption('menuItemOptions'), this),
          Mn._getValue(component.tabMenuItem, this),
          {
            type: UIKit.Menu.Item
          }
        ));

        this.add(menuItemView, contentView, this.configureTabView);
      }, this);
    },

    configureTabView: function(tabView) {
    },

    getComponents: function() {
      return Mn._getValue(this.getOption('components') || [], this);
    }

  });

  module.exports = TabsContainerView;
});

